import { Box, Button, styled } from '@mui/material';

import { COLORS } from '../../../../../../configs/colors';

export const SelectionContent = styled(Box)({
  padding: 16,
});

export const SectionTitle = styled(Box)({
  fontSize: 13,
  fontWeight: 600,
  color: COLORS.Gray,
  textTransform: 'uppercase',
  letterSpacing: 0.5,
  marginBottom: 12,
  '&:not(:first-of-type)': {
    marginTop: 24,
  },
});

export const PrimaryActionGrid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: 12,
});

export const PrimaryActionOption = styled(Button)`
  padding: 20px;
  min-height: 80px;
  text-transform: none;
  font-size: 15px;
  font-weight: 600;
  border-radius: 12px;
  border: 2px solid ${COLORS.NavyBlue};
  color: ${COLORS.NavyBlue};

  &:hover {
    background-color: ${COLORS.LightBlueBackground};
    border-color: ${COLORS.NavyBlue};
  }
`;

export const SecondaryActionsRow = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  gap: 8,
});

export const ConfirmContent = styled(Box)({
  flex: 1,
  overflowY: 'auto',
});

export const SelectedActionBadge = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 16,
  margin: 16,
  backgroundColor: COLORS.LightBlueBackground,
  border: `2px solid ${COLORS.NavyBlue}`,
  borderRadius: 8,
  fontSize: 18,
  fontWeight: 600,
  color: COLORS.NavyBlue,
});

export const NotesSection = styled(Box)({
  padding: 16,
});

export const NoActionsMessage = styled(Box)({
  padding: '32px 16px',
  textAlign: 'center',
  color: COLORS.Gray,
  fontSize: 14,
});

export const LoadingContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 32,
});

export const ErrorMessage = styled(Box)({
  padding: '12px 16px',
  backgroundColor: COLORS.LightRedBackground,
  color: COLORS.DarkRed,
  borderRadius: 8,
  margin: 16,
  fontSize: 14,
});

export const SerialSection = styled(Box)({
  padding: '0 16px 16px',
});

export const SerialLabel = styled(Box)({
  fontSize: 14,
  fontWeight: 600,
  color: COLORS.NavyBlue,
  marginBottom: 8,
});

export const SelectedSerialChip = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 16px',
  backgroundColor: COLORS.LightBlueBackground,
  border: `1px solid ${COLORS.NavyBlue}`,
  borderRadius: 8,
  marginBottom: 8,
});

export const SerialInfo = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
});

export const SerialNumber = styled(Box)({
  fontSize: 14,
  fontWeight: 600,
  color: COLORS.NavyBlue,
});

export const PartTypeName = styled(Box)({
  fontSize: 12,
  color: COLORS.Gray,
});

// Replace flow styles
interface FlowCardProps {
  cardColor: string;
}

export const ReplaceFlowLayout = styled(Box)({
  padding: '0 16px 16px',
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
});

export const FlowCard = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'cardColor',
})<FlowCardProps>(({ cardColor }) => ({
  padding: 12,
  borderRadius: 12,
  backgroundColor: cardColor,
}));

export const FlowCardLabel = styled(Box)({
  fontSize: 11,
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: 1,
  marginBottom: 8,
  color: COLORS.Gray,
});

export const FlowArrowContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '4px 0',
});

// Exceptional part creation styles
export const ExceptionalSection = styled(Box)({
  padding: '0 16px 16px',
  display: 'flex',
  flexDirection: 'column',
  gap: 0,
});

export const ExceptionalMessage = styled(Box)({
  fontSize: 13,
  color: COLORS.Gray,
  backgroundColor: COLORS.LightBlueBackground,
  borderRadius: 8,
  padding: '10px 12px',
  marginBottom: 16,
  lineHeight: 1.5,
});

export const ExceptionalImageCaptureRow = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 12,
  marginTop: 4,
});

export const ExceptionalImageCapture = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

// Part type selection styles
export const PartTypeSearchBox = styled(Box)({
  position: 'sticky',
  top: 0,
  zIndex: 1,
  backgroundColor: COLORS.White,
  padding: '12px 16px',
});

export const PartTypeList = styled(Box)({
  padding: '0 16px',
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  overflowY: 'auto',
  flex: 1,
});

export const PartTypeOption = styled(Button)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  textTransform: 'none',
  padding: '12px 16px',
  borderRadius: 8,
  width: '100%',
});
